import { useRef } from 'react';
import { clamp } from './../utils';

export const useClampWithinElement = ({
  height,
  mouseX,
  mouseY = 0,
  offset = 20,
}: {
  height: number;
  mouseX: number;
  mouseY?: number;
  offset?: number;
}) => {
  const clampedEl = useRef<HTMLDivElement>(null);

  const maxHeight = height - (clampedEl.current?.offsetHeight ?? 0);
  const y = clamp(
    mouseY - offset - (clampedEl.current?.offsetHeight ?? 0),
    maxHeight,
    0
  );

  const tooltipWidth = clampedEl.current?.offsetWidth ?? 0;
  const hasTouchedLeftBound = mouseX - tooltipWidth - offset < 0;

  const x = mouseX + (offset / 2) * (hasTouchedLeftBound ? -1 : 1);

  const isPositioned = x > 0;

  return { clampedEl, x, y, hasTouchedLeftBound, isPositioned };
};
